// Components
import Container from '@/components/elements/Container.vue'
import Button from '@/components/elements/Button.vue'
import Alert from '@/components/elements/Alert.vue'
import Spinner from '@/components/elements/Spinner.vue'
import Chip from '@/components/elements/Chip.vue'
import Icon from '@/components/elements/Icon.vue'
import PageTitle from '@/components/elements/PageTitle.vue'
import Breadcrumbs from '@/components/elements/Breadcrumbs.vue'
import Layout from '@/components/elements/Layout.vue'
import Summary from '@/components/elements/Summary.vue'
import Card from '@/components/elements/Card.vue'
import Collapse from '@/components/elements/Collapse.vue'
import Dropdown from '@/components/elements/Dropdown.vue'
import DropdownField from '@/components/elements/DropdownField.vue'
import DropdownItem from '@/components/elements/DropdownItem.vue'
import Avatar from '@/components/elements/Avatar.vue'
import InputGroup from '@/components/elements/InputGroup.vue'
import Tooltip from '@/components/elements/Tooltip.vue'
import Html from '@/components/elements/Html.vue'
import Errors from '@/components/elements/Errors.vue'
import Error from '@/components/elements/Error.vue'
import Pager from '@/components/elements/Pager.vue'
import Dialog from '@/components/elements/Dialog.vue'
import Truncate from '@/components/elements/Truncate.vue'

// Fields
import Text from '@/components/fields/Text.vue'
import Date from '@/components/fields/Date.vue'
import Checkbox from '@/components/fields/Checkbox.vue'
import List from '@/components/fields/List.vue'
import Number from '@/components/fields/Number.vue'
import Signature from '@/components/fields/Signature.vue'
import TextArea from '@/components/fields/TextArea.vue'
import Toggle from '@/components/fields/Toggle.vue'
import Select from '@/components/fields/Select.vue'

// Blocks
// import HeroBlock from '@/components/pages/blocks/Hero.vue'
// import ServicesBlock from '@/components/pages/blocks/Services.vue'
// import EmployeesBlock from '@/components/pages/blocks/Employees.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component(Container.name, Container)
  nuxtApp.vueApp.component(Button.name, Button)
  nuxtApp.vueApp.component(Alert.name, Alert)
  nuxtApp.vueApp.component(Spinner.name, Spinner)
  nuxtApp.vueApp.component(Chip.name, Chip)
  nuxtApp.vueApp.component(Icon.name, Icon)
  nuxtApp.vueApp.component(PageTitle.name, PageTitle)
  nuxtApp.vueApp.component(Breadcrumbs.name, Breadcrumbs)
  nuxtApp.vueApp.component(Layout.name, Layout)
  nuxtApp.vueApp.component(Summary.name, Summary)
  nuxtApp.vueApp.component(Card.name, Card)
  nuxtApp.vueApp.component(Collapse.name, Collapse)
  nuxtApp.vueApp.component(Dropdown.name, Dropdown)
  nuxtApp.vueApp.component(DropdownField.name, DropdownField)
  nuxtApp.vueApp.component(DropdownItem.name, DropdownItem)
  nuxtApp.vueApp.component(Avatar.name, Avatar)
  nuxtApp.vueApp.component(InputGroup.name, InputGroup)
  nuxtApp.vueApp.component(Tooltip.name, Tooltip)
  nuxtApp.vueApp.component(Html.name, Html)
  nuxtApp.vueApp.component(Errors.name, Errors)
  nuxtApp.vueApp.component(Error.name, Error)
  nuxtApp.vueApp.component(Pager.name, Pager)
  nuxtApp.vueApp.component(Dialog.name, Dialog)
  nuxtApp.vueApp.component(Truncate.name, Truncate)

  nuxtApp.vueApp.component(Text.name, Text)
  nuxtApp.vueApp.component(Date.name, Date)
  nuxtApp.vueApp.component(Checkbox.name, Checkbox)
  nuxtApp.vueApp.component(List.name, List)
  nuxtApp.vueApp.component(Number.name, Number)
  nuxtApp.vueApp.component(Signature.name, Signature)
  nuxtApp.vueApp.component(TextArea.name, TextArea)
  nuxtApp.vueApp.component(Toggle.name, Toggle)
  nuxtApp.vueApp.component(Select.name, Select)

  // nuxtApp.vueApp.component(HeroBlock.name, HeroBlock)
  // nuxtApp.vueApp.component(ServicesBlock.name, ServicesBlock)
  // nuxtApp.vueApp.component(EmployeesBlock.name, EmployeesBlock)
})
